import { create } from "zustand";

export type AuthUser = {
  id: string;
  tenant_id: string;
  email: string;
  first_name: string;
  last_name: string;
  role: string;
  is_active: boolean;
  email_verified_at: string | null;
  last_login_at: string | null;
};

type AuthState = {
  user: AuthUser | null;
  accessToken: string | null;
  bootstrapped: boolean;
  setSession: (user: AuthUser, accessToken: string) => void;
  setAccessToken: (accessToken: string) => void;
  clear: () => void;
  markBootstrapped: () => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  accessToken: null,
  bootstrapped: false,
  setSession: (user, accessToken) => { set({ user, accessToken, bootstrapped: true }); },
  setAccessToken: (accessToken) => { set({ accessToken }); },
  clear: () => { set({ user: null, accessToken: null, bootstrapped: true }); },
  markBootstrapped: () => { set({ bootstrapped: true }); },
}));
